// extracted by mini-css-extract-plugin
export default {"guide__message__area":"TimelineEmpty_guide__message__area__fdq+k","guide__message__box":"TimelineEmpty_guide__message__box__Kyxd9"};